import React from 'react'
import { history } from './App'
import { useStateValue } from '@State'

export const Order = ({
  orderId,
  orderedCourse,
  orderedCourseTitle,
  created,
  numCodes,
  institution,
  invoiceStatus,
  index,
  invoiceNum,
  pmtDate,
  sentOn
}) => {
  let [currentState] = useStateValue()

  const navToOrderDetails = () => {
    history.push(
      `/account/admin_coupons.management/${currentState.coursenum}/details/${orderId}`
    )
  }

  const getLabelClass = invStatus => {
    if (invStatus === 'Paid') {
      return 'label-success'
    } else if (invStatus === 'Outstanding') {
      return 'label-warning'
    } else {
      return 'label-default'
    }
  }

  let invoiceData = invoiceNum ? 'Invoice ' + invoiceNum : <i>No invoice</i>
  let paymentDataDisconnect = (invoiceStatus === 'Paid' && !pmtDate) || (invoiceStatus !== 'Paid' && pmtDate);

  return (
    <div
      onClick={navToOrderDetails}
      className={`p-3 ${
        index === 0 ? 'mb-2' : 'my-2'
      } d-flex justify-content-between align-items-center card-myed access_code_order`}
      style={{"cursor": "pointer"}}
    >
      <div className="ml-4 minw-20">
        <span>{created}</span>
      </div>
      <div className="minw-20 text-center">
        <span>{institution}</span>
      </div>
      <div className="minw-20">
        <div>Course number: {orderedCourse}</div>
        <div>{orderedCourseTitle}</div>
      </div>
      <div className="minw-20 text-center">
        <span>{numCodes} codes</span>
      </div>
      <div className="minw-20">
        <div>
          {invoiceData} <span className={`label ml-3 mb-2 ${getLabelClass(invoiceStatus)}`}>{invoiceStatus}</span>
          {paymentDataDisconnect && <span title="This order has been marked as paid but is missing a pay date." className="ml-3far fa-exclamation-triangle text-danger"></span>}
          {sentOn && <i className="fa-light fa-paper-plane ml-3" title="Codes sent"></i>}
        </div>
      </div>
    </div>
  )
}
